/**
 * What kind of site this is, from `integration_type_name` (reconciled with
 * redesign-be's audit of the connector factory and admin's integration flags,
 * 2026-09-27; reference: ENG-2046). The family decides which signals can say
 * "working right now" and whether silence is normal. How the site is reached
 * (direct / WireGuard / site-to-site) is separate: see `connectionKindForSite`.
 */
export type SiteFamily =
  | "rtsp-pull"
  | "vms-pull"
  | "milestone"
  | "cloud-pull"
  | "smtp-push"
  | "clips-push"
  | "patrol"
  | "other";

/** Admin collapses every is_rtsp integration (hikvision, axis, …) to "rtsp". */
const RTSP_PULL = [
  "rtsp",
  "onvif_wireguard",
  "alibi",
  "orchid",
  "wisenet",
  "lightapi",
  "milestone_rtsp",
  "adpro",
];
const VMS_PULL = [
  "avigilon",
  "digital_watchdog",
  "genetec",
  "exacq",
  "openeye",
  "video_insight",
  "salient",
  "luxriot",
  "cortrol",
  "hikcentral",
];
const CLOUD_PULL = [
  "eagle_eye",
  "eagle_eye_v3",
  "star4live",
  "ezcloud",
  "kvs",
  "ajax_video",
];
const SMTP_PUSH = ["smtp_per_camera", "hikvision_smtp", "speco_smtp", "ajax"];
const CLIPS_PUSH = ["ailink", "sentinel-verifier", "clips"];
const PATROL = ["autopatrol", "vch"];

export const siteFamily = (
  integrationTypeName: string | null | undefined
): SiteFamily => {
  const name = String(integrationTypeName ?? "").toLowerCase();
  if (SMTP_PUSH.includes(name) || name.includes("smtp")) return "smtp-push";
  if (name === "milestone") return "milestone";
  if (RTSP_PULL.includes(name)) return "rtsp-pull";
  if (VMS_PULL.includes(name)) return "vms-pull";
  if (CLOUD_PULL.includes(name)) return "cloud-pull";
  if (CLIPS_PUSH.includes(name)) return "clips-push";
  if (PATROL.includes(name)) return "patrol";
  return "other";
};

/** A connector runs for the site and reports a heartbeat (rule 3). */
export const familyHasConnectorHeartbeat = (family: SiteFamily): boolean =>
  family !== "clips-push" && family !== "patrol" && family !== "other";

export const FAMILY_LABEL: Record<SiteFamily, string> = {
  "rtsp-pull": "RTSP",
  "vms-pull": "VMS",
  milestone: "Milestone",
  "cloud-pull": "cloud VMS",
  "smtp-push": "SMTP",
  "clips-push": "clips",
  patrol: "AutoPatrol",
  other: "other",
};
